import React, { useEffect } from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import PropertyForm from '../../Property/Property/PropertyForm';

export default function PropertyEditPage({
	get_property_endpoint,
	update_property_endpoint
}) {
	const { id } = useParams();

	const location = useLocation();
	const propertyName = location.state ? location.state.propertyName : '';
	const isEditing = location.state ? location.state.isEditing : '';

	useEffect(
		() => {
			// Log the propertyName to verify it's received correctly
			// console.log('Received propertyName:', propertyName);
			// console.log('Received isEditing:', isEditing);
		},
		[
			id,
			propertyName
		]
	);

	return (
		<div>
			<div className="-mt-8 md:-mt-12 mb-8 md:mb-12 md:text-xl">
				<Link to="/dashboard" className="hover:underline mr-2 md:mr-3">
					Dashboard
				</Link>
				<i
					className="text-gray-400 fa fa-chevron-right text-xs md:text-base mr-2 md:mr-3"
					aria-hidden="true"
				/>
				<Link to={`/properties/${id}`} className="hover:underline mr-2 md:mr-3">
					{propertyName || 'Property Name'}
				</Link>
				<i
					className="text-gray-400 fa fa-chevron-right text-xs md:text-base mr-2 md:mr-3"
					aria-hidden="true"
				/>
			</div>
			<PropertyForm
				id={id}
				propertyName={propertyName}
				isEditing={isEditing}
				get_property_endpoint={get_property_endpoint}
				update_property_endpoint={update_property_endpoint}
			/>
		</div>
	);
}

PropertyEditPage.propTypes = {
	get_property_endpoint: PropTypes.string.isRequired,
	update_property_endpoint: PropTypes.string.isRequired
};
